// extracted by mini-css-extract-plugin
export default {"wrapper":"F2-z","play":"G2-z"};